var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDocumentLight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 55,
    viewBox: "0 0 48 55",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Document_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8267 0.833332H35.176C43.4133 0.833332 48 5.58 48 13.7133V41.26C48 49.5267 43.4133 54.1667 35.176 54.1667H12.8267C4.72 54.1667 0 49.5267 0 41.26V13.7133C0 5.58 4.72 0.833332 12.8267 0.833332ZM13.5467 13.26V13.2333H21.5173C22.6667 13.2333 23.6 14.1667 23.6 15.3107C23.6 16.4867 22.6667 17.42 21.5173 17.42H13.5467C12.3973 17.42 11.4667 16.4867 11.4667 15.34C11.4667 14.1933 12.3973 13.26 13.5467 13.26ZM13.5467 29.4733H34.4533C35.6 29.4733 36.5333 28.54 36.5333 27.3933C36.5333 26.2467 35.6 25.3107 34.4533 25.3107H13.5467C12.3973 25.3107 11.4667 26.2467 11.4667 27.3933C11.4667 28.54 12.3973 29.4733 13.5467 29.4733ZM13.5467 41.66H34.4533C35.5173 41.5533 36.32 40.644 36.32 39.58C36.32 38.4867 35.5173 37.58 34.4533 37.4733H13.5467C12.7467 37.3933 11.9733 37.7667 11.5467 38.46C11.12 39.1267 11.12 40.0067 11.5467 40.7C11.9733 41.3667 12.7467 41.7667 13.5467 41.66Z",
    fill: "#AFAFAF"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDocumentLight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DocumentLight.259268d5.svg";
export { ForwardRef as ReactComponent };